import state from './device.state'
import mutations from './device.mutations'
import actions from './device.actions'
import getters from './device.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



//////////////////
// WEBPACK FOOTER
// ./state/device/device.module.js
// module id = null
// module chunks = 